// extracted by mini-css-extract-plugin
export var externalLink = "_by-0";
export var internalLinkLabel = "_by-1";